import { BlockNoteEditor } from '@blocknote/core';
import { Block, BlockSchema } from '../schema';
import { applyImageBlockPreviewWidth } from './apply-image-block-preview-dimensions';
import getEditorDomSearchRoot from './get-editor-dom-search-root';
import imagePreviewDimensionsNeedSync from './image-preview-dimensions-need-sync';
import measureImagePreviewWidthCssPx from './measure-image-preview-width-css-px';

type SyncImagePreviewDimensionsOptions = {
  measureAllImageDimensionsFromDom?: boolean;
};

export const syncImagePreviewDimensionsInEditor = (
  editor: BlockNoteEditor<BlockSchema>,
  options: SyncImagePreviewDimensionsOptions = {},
) => {
  const editorRoot = getEditorDomSearchRoot(editor);
  if (!editorRoot) {
    return;
  }

  for (const block of editor.document) {
    syncImageBlockPreviewDimensions(editor, editorRoot, block, options);
  }
};

function syncImageBlockPreviewDimensions(
  editor: BlockNoteEditor<BlockSchema>,
  editorRoot: HTMLElement,
  block: Block,
  options: SyncImagePreviewDimensionsOptions,
) {
  if (
    !options.measureAllImageDimensionsFromDom &&
    !imagePreviewDimensionsNeedSync(block)
  ) {
    return;
  }

  if (block.type !== 'image' || !imagePreviewDimensionsNeedSync(block)) {
    return;
  }

  const previewWidth = measureImagePreviewWidthCssPx(editorRoot, block.id);
  if (previewWidth === null) {
    return;
  }

  applyImageBlockPreviewWidth(editor, block.id, previewWidth);
}
